import ThemedIcon from '@/components/ui/ThemedIcon';
import { cn } from '@/utils/tailwind-merge';
import { useTranslations } from 'next-intl';
import P from '../ui/P';

export default function AccreditationSuccess({
    isPress,
    className,
}: {
    isPress?: boolean;
    className?: string;
}) {
    const t = useTranslations('AccreditationPage');

    return (
        <div
            className={cn(
                'border border-gray3 py-[70px] px-4 flex flex-col gap-7 justify-center items-center border-white',
                className,
            )}
        >
            <ThemedIcon
                aria-label="Success icon"
                className="text-primary"
                src="/img/icons/check.svg"
                width={64}
                height={64}
            />
            <h3 className="uppercase max-lg:text-h4 lg:text-h3 leading-none">{t('thankYou')}</h3>
            <P className={cn('w-full text-center font-helvetica-neue font-light text-white')}>
                {t('thankYouDescription')}
            </P>
            <P className={cn('w-full text-center font-helvetica-neue font-light text-white')}>
                {t('weLookForward')}
            </P>
            <P className={cn('w-full text-center font-helvetica-neue font-light text-white')}>
                {t('contact')}{' '}
                {isPress ? (
                    <a href="danny@raisondetremedia.ca">danny@raisondetremedia.ca</a>
                ) : (
                    <a href="mailto:contact@image-nation.org">contact@image-nation.org</a>
                )}
            </P>
        </div>
    );
}
